import loadable from "utils/loadable";

export const HalamanLogin = loadable(() => import("./index"));
export const ForgotPassword = loadable(() => import("./ForgotPassword"));
export const MemberArea = loadable(() => import("./MemberArea"));
export const SignInCard = loadable(() => import("./SignInCard"));
export const VerifyEmail = loadable(() => import("./VerifyEmail"));
